<template>
	<div>
		<s-crud
			title="Maestro de Envases (SKUs)"
			:config="config"
			:filter="filter"
			height="calc(100vh - 250px)"
			:add="canManageMaster"
			:edit="canManageMaster"
			:remove="canManageMaster"
			searchInput
			@save="save($event)"
			ref="gridContainerMaster"
		>
			<!-- FORMULARIO DE REGISTRO / EDICIÓN -->
			<template v-slot="props">
				<v-container fluid class="pa-2" v-if="props && props.item">
					<v-card flat class="cm-form-card cm-tone-purple mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="16" color="#7a5cf0">mdi-package-variant</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Datos Principales del Envase / SKU</div>
								<div class="cm-section-subtitle">Definición técnica y características comerciales</div>
							</div>
						</div>
						<div class="cm-section-body">
							<v-row justify="start">
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-text
										label="Código SKU *"
										v-model="props.item.CmtCode"
									></s-text>
								</v-col>
								<v-col cols="12" md="8" class="s-col-form pb-0">
									<s-text
										label="Descripción del Envase *"
										v-model="props.item.CmtDescription"
									></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-definition
										:def="1728"
										label="Tipo Envase"
										v-model="props.item.CmtContainerTypeID"
										add
										clearable
										searchable
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-definition
										:def="1729"
										label="Color"
										v-model="props.item.CmtColorID"
										add
										clearable
										searchable
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-text
										label="Peso Tara (Kg)"
										decimal
										v-model="props.item.CmtTareWeight"
									></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-definition
										:def="1733"
										label="Tipo de Propiedad"
										v-model="props.item.CmtOwnershipTypeID"
										add
										clearable
										searchable
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-text
										label="Stock Mínimo en Planta"
										decimal
										v-model="props.item.CmtMinimumStock"
									></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-text
										label="Costo Unitario (S/)"
										decimal
										v-model="props.item.CmtCost"
									></s-text>
								</v-col>
							</v-row>
						</div>
					</v-card>
				</v-container>
			</template>
		</s-crud>
	</div>
</template>

<script>
import SCrud from "@/components/Utils/SCrud.vue";
import SText from "@/components/Utils/SText.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import _sContainerMasterService from "@/services/Logistics/ContainerMasterService";

export default {
	name: "ContainerMaster",
	components: {
		SCrud,
		SText,
		SSelectDefinition,
	},
	data() {
		return {
			filter: {},
			config: {
				model: {
					CmtID: "ID",
					CmtCode: "",
					CmtDescription: "",
					CmtContainerTypeID: null,
					CmtColorID: null,
					CmtTareWeight: "",
					CmtOwnershipTypeID: null,
					CmtMinimumStock: "",
					CmtCost: "",
				},
				service: _sContainerMasterService,
				headers: [
					{ text: "Código SKU", value: "CmtCode", width: "120" },
					{ text: "Descripción Envase", value: "CmtDescription", width: "220" },
					{ text: "Tipo Envase", value: "CmtContainerTypeName", width: "140" },
					{ text: "Color", value: "CmtColorName", width: "120" },
					{ text: "Tara (Kg)", value: "CmtTareWeight", width: "100" },
					{ text: "Propiedad", value: "CmtOwnershipTypeName", width: "120" },
					{ text: "Stock Mínimo", value: "CmtMinimumStock", width: "120" },
					{ text: "Costo (S/)", value: "CmtCost", width: "100" },
				],
			},
		};
	},
	computed: {
		canManageMaster() {
			return !!(this.$fun.isAdmin() || (this.$fun.getSecurity() && this.$fun.getSecurity().IsLevelAdmin));
		},
	},
	methods: {
		save(item) {
			if (!item) return;
			if (!item.CmtCode || !item.CmtDescription) {
				this.$fun.alert("Por favor complete los campos obligatorios: Código SKU y Descripción", "warning");
				return;
			}

			item.UsrCreateID = this.$fun.getUserID();
			item.UsrUpdateID = this.$fun.getUserID();
			item.SecStatus = 1;

			item.save();
		},
	},
};
</script>

<style scoped>
.cm-form-card {
	border-radius: 12px;
	padding: 16px;
	border: 1px solid rgba(0, 0, 0, 0.08);
}
.cm-tone-purple {
	background: #fcfaff;
	border-color: #e2d9fc;
}
.cm-section-header {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
}
.cm-section-icon {
	width: 32px;
	height: 32px;
	border-radius: 8px;
	background: #f0ebff;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px;
}
.cm-section-title {
	font-weight: 700;
	font-size: 0.95rem;
	color: #1e293b;
}
.cm-section-subtitle {
	font-size: 0.75rem;
	color: #64748b;
}
</style>
